import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Links = lazy(() => import('../pages/links/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/links',
    element: <Links />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;